import * as Yup from 'yup'

export const validationSchema = Yup.object({
  translation: Yup.object().shape({
    name: Yup.string().required(),
  })
})